module.exports = __webpack_public_path__ + "img/logo-serviroute.f1a0c383.png";